import { clearAllTilesColor } from '../Color';
import { resetData } from '../index';
import EventKeys from '../../../constants/EventKeys';

// End the current turn
export function endThisTurn() {
  clearAllTilesColor.call(this);
  resetData.call(this);
  this.events.emit(EventKeys.TurnNextHero);
}
